export abstract class AbstractPagingResponseModel<T> {
	public count: number;

	public abstract results: T[];
}
